<template>
  <div style="width: 100%; height: 100%">
    <transition name="floatTransition" appear>
      <div :class="$style.background" v-show="sideBarVisible">
        <div :class="$style.suspendWindow">
          <ul :class="$style.tabs">
            <li v-for="(tabItem, tabIndex) in tabs" :key="tabIndex" @click="changeTab(tabItem)" v-show="tabItem.show">
              <img
                :src="activeTab.type === tabItem.type ? tabItem.activeIcon : tabItem.icon"
                :class="[tabItem.type === 'welfare' ? $style.welfareActive : '']"
              />
              <span>{{ tabItem.name }}</span>
              <span :class="$style.hint" v-if="tabItem.hint"></span>
            </li>
          </ul>
          <!-- 个人中心 -->
          <Personal v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'geren'"></Personal>
          <!-- 快手活动 -->
          <Active v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'active'" :realDay="realDay"></Active>
          <!-- 福利 -->
          <Welfare v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'welfare'"></Welfare>
          <!-- 首页 -->
          <Home v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'home'" @redirectArticle="redirectArticle"></Home>
          <!-- 竖屏 情报/攻略 菜单页 -->
          <PortraitRaiders
            v-bind="$attrs"
            v-on="$listeners"
            v-if="['messages', 'raiders'].includes(activeTab.type) && y_portrait"
            :tabType="activeTab.type"
          ></PortraitRaiders>
          <!-- 新游推荐 -->
          <NewGameRecommend v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'newGame'"></NewGameRecommend>
          <HangUp v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'hangup'"></HangUp>
        </div>
      </div>
    </transition>
    <!-- 横屏 情报/攻略 -->
    <Raiders
      v-bind="$attrs"
      v-on="$listeners"
      v-if="['messages', 'raiders'].includes(activeTab.type) && !y_portrait"
      :tabType="activeTab.type"
      @showSideWindow="showSideWindow"
    ></Raiders>
    <!-- 竖屏 情报/攻略 文章详情页 -->
    <PortraitArticle v-bind="$attrs" v-on="$listeners" v-if="portraitArticleVisible" @showSideWindow="showSideWindow('article')"></PortraitArticle>
    <!-- 客服 -->
    <Customer v-bind="$attrs" v-on="$listeners" v-if="activeTab.type === 'kefu'" @showSideWindow="showSideWindow"></Customer>
    <!-- 活动计划页 -->
    <Summary v-if="summaryVisible" :isSuspend="true"></Summary>
    <!-- 公众号 -->
    <OfficialWechat v-if="activeTab.type === 'officialWechat'" @close="showSideWindow"></OfficialWechat>
    <GiftRemind v-if="giftRemindShow" :code="giftCode" @close="closeGiftRemind"></GiftRemind>
    <CloudCharge v-if="cloudChargeVisible"></CloudCharge>
    <BindPhone v-if="bindPhoneVisible" :bindHintText="bindHintText" :fullScreenFlag="true" @back="closeBindPhone" :class="$style.bindPhone"></BindPhone>
  </div>
</template>

<script>
import Home from './Home.vue';
import Customer from './Customer.vue';
import Personal from './Personal/index.vue';
import Active from './Active.vue';
import { mapState } from 'vuex';
import Summary from '@/views/client/activity/summary.vue';
import OfficialWechat from './OfficialWechat.vue';
import Welfare from './Welfare';
import Raiders from './Raiders/index.vue';
import PortraitRaiders from './Raiders/portraitMenu.vue';
import PortraitArticle from './Raiders/portraitArticle.vue';
import NewGameRecommend from './NewGameRecommend.vue';
import { getRealDayApi } from '@/api/ks';
import { y_portrait } from '~utils';
import { buryReportV2 } from '@/libs/business/account';
import GiftRemind from '@/components/Suspend/Welfare/GiftRemind' 
import HangUp from './HangUp'
import CloudCharge from '@/components/charge/Cloud/index.vue'
import BindPhone from '@/components/login/BindPhone';

export default {
  name: '',
  inheritAttrs: false,
  data() {
    return {
      realDay: -1,
      activityState: true,
      y_portrait: false,
    };
  },
  watch: {
    activeTab(val) {
      if (val.type === 'home') {
        buryReportV2('SDK_MENU_HOME', { menu_name: "首页" })
      } else if (val.type === 'geren') {
        buryReportV2('SDK_MENU_PERSONAL', { menu_name: "个人" })
      } else if (val.type === 'welfare') {
        // buryReportV2('SDK_MENU_PROFIT', { menu_name: "福利" })
        // 福利页上报调整到具体触发位置场景上报 点击 活动跳转 闪页跳转
      } else if (val.type === 'messages') {
        buryReportV2('SDK_MENU_INFORMATION', { menu_name: "情报" })
      } else if (val.type === 'raiders') {
        buryReportV2('SDK_MENU_STRATEGY', { menu_name: "攻略" })
      } else if (val.type === 'newGame') {
        buryReportV2('SDK_MENU_NEW_GAME', { menu_name: "新游" })
      } else if (val.type === 'kefu') {
        buryReportV2('SDK_MENU_CUSTOMER', { menu_name: "客服" })
      } else if (val.type === 'officialWechat') {
        buryReportV2('SDK_MENU_OFFICIAL', { menu_name: "公众号" })
      } else if (val.type === 'hangup') {
        // buryReportV2('SDK_MENU_CLOUD', { menu_name: "云挂机" })
        // 云挂机上报调整到具体触发位置场景上报 点击 活动跳转 闪页跳转
      }
    }
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
      summaryVisible: (state) => state.suspend.summaryVisible,
      sideBarVisible: (state) => state.suspend.sideBarVisible,
      officialWechatVisible: (state) => state.suspend.officialWechatVisible,
      tabs: (state) => state.suspend.tabs,
      portraitArticleVisible: (state) => state.suspend.portraitArticleVisible,
      giftRemindShow: (state) => state.suspend.giftRemindShow,
      giftCode: (state) => state.suspend.giftCode,
      cloudChargeVisible:  (state) => state.suspend.cloudChargeVisible,
      bindHintText: (state) => state.suspend.bindHintText,
      bindPhoneVisible: (state) => state.suspend.bindPhoneVisible,
      activeTab: (state) => state.suspend.activeTab,
    }),
  },
  async mounted() {
    this.y_portrait = y_portrait();
    await this.$store.dispatch('suspend/initTab');
    // 获取情报信息菜单列表 在这里获取是因为情报需要判断展示红点
    this.$store.dispatch('suspend/getMessagesList');
    this.$store.dispatch('suspend/getRaidersList');
    // 获取首页数据
    this.$store.dispatch('suspend/getHomeData');
    // 获取新游数据
    this.$store.dispatch('suspend/getNewGameData');
    // 获取盒子下载链接
    this.$store.dispatch('user/getBoxDownloadUrl');
    // 获取云挂机配置
    // this.$store.dispatch('suspend/getProductList');
    
    setTimeout(() => { 
      this.initTab();
    }, 200);
  },
  methods: {
    initTab() {
      const { FRArticleId, FRMenuId, FRType } =this.$route.query;
      const { strongRemindFlag, remind } = this.$store.state.suspend;
      if ((FRArticleId && FRMenuId && FRType) && !strongRemindFlag) {
        this.$store.commit('suspend/CHANGE_STATE', {
          redirectArticle: {
            type: FRType,
            article_id: FRArticleId,
            menu_id: FRMenuId,
          },
          active_menu_type: FRType == 2 ? 'raiders' : 'messages',
          strongRemindFlag: true
        })
        this.redirectArticle(FRType);
      } else if (remind.remind == 1) {
        // h5
        this.$store.commit('suspend/CHANGE_STATE', {
          redirectArticle: {
            type: remind.remind_type,
            article_id: remind.remind_article_id,
            menu_id: remind.remind_menu_id,
          },
          remind: {
            ...remind,
            remind: 0
          },
          active_menu_type: remind.remind_type == 2 ? 'raiders' : 'messages',
        })
        this.redirectArticle(remind.remind_type);
      } else {
        this.$store.commit('suspend/CHANGE_STATE', { activeTab: this.tabs.find(item => item.show === true) })
      }
    },
    changeTab(tabItem) {
      this.$store.commit('suspend/CHANGE_STATE', { activeTab: tabItem })
      // 客服公众号为全屏弹窗，需要隐藏菜单
      // 情报/攻略 竖屏在菜单内，横屏为全屏框 暂未做ipad特殊处理
      if (
        ['kefu', 'officialWechat'].includes(this.activeTab.type) ||
        (['messages', 'raiders'].includes(this.activeTab.type) && !this.y_portrait)
      ) {
        this.setSideBarState(false);
      }
      if (tabItem.type === 'welfare') {
        buryReportV2('SDK_MENU_PROFIT', { menu_name: "福利", upload_type: "点击上报" })
      } else if (tabItem.type === 'hangup') {
        this.$setStorage('buryport', {
          upload_type: '点击上报',
        })
      }
    },
    // 2. 攻略 3.消息
    redirectArticle(type) {
      if (!this.y_portrait) {
        switch(type) {
          case '2':
          case 2:
            this.changeTab({ type: 'raiders' });
            break;
          case '3':
          case 3:
            this.changeTab({ type: 'messages' });
            break;
        }
      } else {
        this.$store.commit('suspend/CHANGE_STATE', {
          sideBarVisible: false,
          portraitArticleVisible: true,
        });
      }
    },
    setSideBarState(state) {
      this.$store.commit('suspend/CHANGE_STATE', { sideBarVisible: state });
    },
    showSideWindow(type) {
      if (type !== 'article' || !this.activeTab.type){
        // 部分全屏弹框回来时候需要切换到其他tab
        this.changeTab(this.tabs.find(item => item.show === true));
      }
      this.$store.commit('suspend/CHANGE_STATE', { sideBarVisible: true, portraitArticleVisible: false });
    },
    // $$快手活动使用
    async getRealDay(data) {
      if (!data.length) {
        this.realDay = -1;
        return;
      }
      try {
        const r = await getRealDayApi({
          user_id: this.userState.user_id,
          appkey: this.userState.appkey,
          access_token: this.userState.access_token,
          parent_task_id: data[0].parent_task_id
        });

        this.realDay = r.content.register_day == 0 ? 1 : r.content.register_day;
        const is_use_ks_sdk = localStorage.getItem('is_use_ks_sdk') === 'true';
        if (is_use_ks_sdk) {
          this.$store.commit('suspend/SET_TAB', { action: 'show', val: 'active' });
          this.$store.commit('suspend/CHANGE_STATE', { activeTab: this.tabs.find(item => item.show === true) })
        }
      } catch (e) {
        this.realDay = -1;
      }
    },
    closeGiftRemind() {
      this.$store.commit('suspend/CHANGE_STATE', { giftRemindShow: false });
    },
    closeBindPhone() {
      this.$store.commit('suspend/CHANGE_STATE', { bindPhoneVisible: false });
    }
  },
  components: {
    Customer,
    Personal,
    Active,
    Summary,
    OfficialWechat,
    Welfare,
    Home,
    Raiders,
    PortraitRaiders,
    PortraitArticle,
    NewGameRecommend,
    GiftRemind,
    HangUp,
    CloudCharge,
    BindPhone
  },
};
</script>

<style lang="scss" module>
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  15% {
    -webkit-transform: rotate(-20deg);
  }
  30% {
    -webkit-transform: rotate(0);
  }
  45% {
    -webkit-transform: rotate(20deg);
  }
  60% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 0;
  z-index: $float-window;
  .suspendWindow {
    display: flex;
    height: 100vh;
    @media screen and (orientation: portrait) {
      position: absolute;
      bottom: 0;
      height: 50vh;
      min-height: 373px;
      width: 100%;
    }
    .tabs {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      width: 38px;
      height: 100%;
      justify-content: space-around;
      background: #000000;
      opacity: 0.85;
      > li {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #ffffff;
        > img {
          width: 22px;
          margin-bottom: 2px;
        }
        .welfareActive {
          animation: turn 1.5s linear infinite;
        }
        > span {
          font-size: 9px;
        }
        .hint {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #da3c22;
          top: 0;
          right: 5px;
        }
      }
    }
  }
}
.bindPhone {
  z-index: 99!important;
}
</style>
<style lang="scss">
.floatTransition-enter-active,
.floatTransition-leave-active {
  transition: all 0.8s ease;
}
.floatTransition-enter,
.floatTransition-leave-to {
  transform: translate3d(-100%, 0, 0);
}
.floatTransition-enter-to,
.floatTransition-leave {
  transform: translate3d(0, 0, 0);
}
</style>
